import { render, staticRenderFns } from "./GameOverModal.vue?vue&type=template&id=37249854&scoped=true"
import script from "./GameOverModal.vue?vue&type=script&lang=js"
export * from "./GameOverModal.vue?vue&type=script&lang=js"
import style0 from "./GameOverModal.vue?vue&type=style&index=0&id=37249854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37249854",
  null
  
)

export default component.exports